let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hz3TQ")).then(() => parcelRequire('9OZDh'));